export default {"src":"/_next/static/media/pets.47d5c4a3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};